import React, { useState } from 'react';
import styled from 'styled-components';
import StyledText from '../../../components/StyledComponents/StyledText';
import { CorporateTheme, CreateFormTheme } from '../../../utils/themes';
import { hexToRgba } from '../../../utils/helper';

const Card = styled.div<{ width?: string }>`
  background-color: ${hexToRgba('#F59E0B', 0.05)};
  padding: 5px 24px;
  border-radius: 5px;
    width: ${({ width }) => width || '306px'};
  min-height: 167px;
  border: 1px solid #F59E0B;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid ${hexToRgba('#F59E0B', 0.3)};
  margin-bottom: 16px;
`;

const Tab = styled.div<{ active: boolean; tabFontSize?: string }>`
  cursor: pointer;
  padding: 12px 0;
  border-bottom: 2px solid ${props => props.active ? 'var(--app-primary-color)' : 'transparent'};
  font-weight: ${props => props.active ? 700 : 600};
  color: ${props => props.active ? 'var(--app-primary-color)' : '#6b7280'};
  font-size: ${props => props.tabFontSize || '14px'};
  transition: all 0.2s ease;
  
  &:hover {
    color: var(--app-primary-color);
  }
`;

const Row = styled.div`
  display: flex;
  gap: 5px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #6b7280;
`;

const Value = styled.span`
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
`;

interface InfoItem {
    label: string;
    value: string;
}

interface ContactInfoCardProps {
    title?: string;
    items?: InfoItem[];
    aboutUserItems?: InfoItem[];
    lastLoginItems?: InfoItem[];
    tabFontSize?: string;
    width?: string;
}

export const ContactInfoCard: React.FC<ContactInfoCardProps> = ({
    title,
    items,
    aboutUserItems = [],
    lastLoginItems = [],
    tabFontSize = '14px',
    width
}) => {
    const [activeTab, setActiveTab] = useState(1);

    const tabs = [
        { id: 1, label: 'About this User' },
        { id: 2, label: 'Last Login Activity' },
    ];

    const renderTabContent = () => {
        switch (activeTab) {

            case 1:
                return (
                    <div className='d-flex flex-column gap-2'>
                        {aboutUserItems.length > 0 ? (
                            aboutUserItems.map((item, index) => (
                                <Row key={index}>
                                    <StyledText textColor={'var(--app-text-color)'} fontWeight={600} fontSize='13px'>{item.label}:</StyledText>
                                    <StyledText textColor={'var(--app-text-color)'} fontWeight={500} fontSize='13px'>{item.value}</StyledText>
                                </Row>
                            ))
                        ) : (
                            <StyledText textColor={'#9ca3af'} fontSize='13px'>No user information available</StyledText>
                        )}
                    </div>
                );
            case 2:
                return (
                    <div className='d-flex flex-column gap-2'>
                        {lastLoginItems.length > 0 ? (
                            lastLoginItems.map((item, index) => (
                                <Row key={index}>
                                    <StyledText textColor={'var(--app-text-color)'} fontWeight={600} fontSize='13px'>{item.label}:</StyledText>
                                    <StyledText textColor={'var(--app-text-color)'} fontWeight={500} fontSize='13px'>{item.value}</StyledText>
                                </Row>
                            ))
                        ) : (
                            <StyledText textColor={'#9ca3af'} fontSize='13px'>No login activity available</StyledText>
                        )}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Card width={width}>
            <TabsContainer>
                {tabs.map((tab) => (
                    <Tab
                        key={tab.id}
                        active={activeTab === tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        tabFontSize={tabFontSize}
                    >
                        {tab.label}
                    </Tab>
                ))}
            </TabsContainer>
            <div>
                {renderTabContent()}
            </div>
        </Card>
    );
};